module.exports = __webpack_public_path__ + "media/icons/msg-file-f8d47307.png";